import { ResponsiveBar } from "@nivo/bar";
import { palette } from "./constants";
import { Histogram } from "@/features/survey-results/survey-results-types";

interface OpinionScaleChartProps {
  histogram?: Histogram;
  range: { min: number; max: number };
}

const OpinionScaleChart: React.FC<OpinionScaleChartProps> = ({
  histogram,
  range,
}) => {
  if (!histogram || histogram.length == 0) {
    return <div className="text-slate-400">No data</div>;
  }
  const data = formatData(histogram, range);
  if (!data) {
    return <div>No data</div>;
  }

  return (
    <ResponsiveBar
      data={data}
      // maxValue={0}
      minValue={0}
      keys={["value"]}
      indexBy="choice"
      margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
      padding={0.2}
      colors={palette}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        // legend: "Choices"
        // legendPosition: "middle",
        // legendOffset: 40,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Count",
        legendPosition: "middle",
        legendOffset: -50,
      }}
      tooltip={(tooltip: any) => (
        <div
          style={{
            padding: "10px",
            backgroundColor: "#333",
            color: tooltip.color,
            borderRadius: "5px",
            fontSize: "14px",
          }}
        >
          <strong>{tooltip.indexValue}</strong>: {tooltip.value}
        </div>
      )}
      enableLabel={false}
      borderRadius={2}
      borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
      theme={{
        // textColor: "#fff", // Set all text to white
        axis: {
          legend: {
            text: {
              fill: "#fff", // Axis legend text
            },
          },
          ticks: {
            text: {
              fill: "#fff", // Axis tick labels
            },
          },
        },
        tooltip: {
          container: {
            color: "#fff", // Tooltip text
          },
        },
        labels: {
          text: {
            fill: "#fff", // Bar label text
          },
        },
      }}
    />
  );
};

function formatData(histogram: Histogram, range: { min: number; max: number }) {
  const { min, max } = range;
  const data = [];
  let maxValue = 0;
  for (let i = min; i <= max; i++) {
    const count = searchHistogram(histogram, i);
    data.push({
      choice: i.toString(),
      value: count,
    });
    if (count > maxValue) {
      maxValue = count;
    }
  }
  if (maxValue === 0) {
    return null;
  }
  return data;
}

function searchHistogram(histogram: Histogram, choice: number) {
  const item = histogram.find((it) => it.choice == String(choice));
  if (!item) {
    return 0;
  }
  return item.count;
}

export default OpinionScaleChart;
